<ng-template #classic let-c="close" let-d="dismiss" id="info-modal">
    <div class="modal-content">
        <div class="d-flex flex-column align-items-center">
            <div class="modal-title text-center mb-3" id="modal-title-default" *ngIf="title">
                {{ title }}
            </div>
            <div class="text-center font-14 mb-3" *ngIf="message">
                {{ message }}
            </div>
            <div class="text-center mb-3">
                <div *ngIf="success; else error">
                    <i class="material-icons success">check_circle</i>
                </div>
                <ng-template #error>
                    <i class="material-icons error">error</i>
                </ng-template>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button type="button" class="modal-ok-btn" ngbAutofocus (click)="modalReference.close(true)">
                {{ 'CONSTANTS.BTN_OK' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>